import {FC, RefObject, useContext, useEffect, useRef} from "react";
import styles from "./HomeComponent.module.css";
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {Tab} from "@components/Tab/Tab";
import {ReactComponent as Logo} from "@/assets/svg/logo.svg";
import {Button} from "@components/Button/Button";
import {HeaderContext} from "@/providers/HeaderContext";
import {TabContext} from "@/providers/TabContext";
import Hls from "hls.js";
import {SearchComponent} from "@components/SearchComponent/SearchComponent";
import {Icon} from "@components/Icon/Icon";

declare global {
  interface Window {
    ym: (
      counterId: number,
      action: string,
      ...args: any[]
    ) => void;
    _tmr: any[]; // если используете Top.Mail.Ru
  }
}

gsap.registerPlugin(ScrollTrigger);

type Props = {
  scrollerRef: RefObject<HTMLElement>;
}

export const HomeComponent: FC<Props> = ({scrollerRef}) => {

  const triggerRef = useRef<HTMLElement>(null);
  const imageBG = useRef<HTMLDivElement>(null);
  const tabContext = useContext(TabContext);

  const headerContext = useContext(HeaderContext);

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (Hls.isSupported() && videoRef.current) {
      const hls = new Hls();
      hls.loadSource("/hls/index.m3u8");
      hls.attachMedia(videoRef.current);
    } else if (videoRef.current && videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
      videoRef.current.src = "/hls/index.m3u8";
    }
  }, []);

  const action = () => {
    window.open('https://neimark.ukmira.ru/register?from=hotel')
    if (typeof window !== 'undefined' && typeof window.ym === 'function') {
      window.ym(105500220,'reachGoal','click-form-hotel')
    }
  }


  return (
    <section ref={triggerRef} className={styles.main}>
      <div className={`${styles.description_section}`}>
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className={styles.video_background}
        />
        <div className={`${styles.gradient_overlay}`}></div>
        <header className={`${styles.header}`}>
          <div className={styles.header_left}>
            <Logo className={styles.logo} onClick={() => window.open('https://neimark-it.ru/')}/>
            <nav className={styles.navigation}>
              <Tab active={false} title={'О нас'} onClick={() => tabContext[1]('about')}/>
              <Tab active={false} title={'Номера'} onClick={() => tabContext[1]('price')}/>
            </nav>
          </div>
          <div className={styles.header_right}>
          </div>
        </header>
        <div className={styles.content}>

          <div className={styles.description_text}>

            <span className={styles.description_place_text}>
              <span className={styles.description_inner_text}>{'Гостиница'}</span>
              <span className={styles.description_inner_text}>{'ИТ\u00A0-кампуса\u00A0НЕЙМАРК'}</span>
            </span>

            <Button title={'Подать заявку'} onClick={action}/>
          </div>

        </div>
      </div>
    </section>
  )

}